<template>
    <div>
        <p>Markeer de legplaats als voltooid.</p>
        <b-button @click="$emit('success')" variant="primary">Voltooid</b-button>
    </div>
</template>

<script>
export default {
    name: "OrderCompletionMarkSortingLocationAsComplete",

    props: {
        sortingZoneIdentifier: {required: true, type: String},
        dispatcherType: {required: true, type: String},
        dispatcherIdentifier: {required: true, type: String},
    },

    data() {
        return {}
    },

    computed: {},

    mounted() {
    },

    methods: {
        getIdentifier() {
            return 'mark_sorting_location_as_complete'
        },
        isRequired(batchModelType, productIdentifier, dispatchRequest, sortingLocation) {
            return Promise.resolve(true)
        },
    },
}
</script>

<style scoped>

</style>
